import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-global-filter',
  templateUrl: './global-filter.component.html',
  styleUrls: ['./global-filter.component.scss'],
})
export class GlobalFilterComponent implements OnInit {
  @Input() table: DatatableComponent;
  @Input() allData;
  @Output() filtered = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {}
  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    const els = val.split(/:/);
    const subject = els[0];
    let data;
    if (!subject) {
      data = this.allData;
      // Whenever the filter changes, always go back to the first page
      this.table.offset = 0;
      return;
    }
    const search = els[1];
    // filter our data
    const temp = this.allData.filter(function (d) {
      return !d[subject.toLowerCase()] || d[subject].toLowerCase().indexOf(search) !== -1 || !search;
    });

    // update the rows
    data = temp;
    this.filtered.emit(data);
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }
}
